/* eslint-disable react/prop-types */
import React, { useContext } from 'react';
import MessageContext from '../../../context/usuario.context';
import './view.message.scss';

function ViewMessage() {
  const {
    message: { message, data },
    setMessage, setTitle,
  } = useContext(MessageContext);

  return (
    <div id="view-message-main">
      <div className="title-view-message">
        <div className="title-message">
          <span>{`Data de Envio: ${data}`}</span>
        </div>
        <div className="go-back-inbox">
          <button
            className="buttons-transparent"
            type="button"
            onClick={() => {
              setMessage({ message: {}, selected: false });
              setTitle('Minhas Mensagens');
            }}
          >
            <i className="far fa-arrow-alt-circle-left">
              <span>Voltar</span>
            </i>
          </button>
        </div>
      </div>

      <div className="body-message">
        <div className="message">
          <span>
            {message}
          </span>
        </div>
      </div>
    </div>
  );
}

export default ViewMessage;
